// Escape JSON for safe embedding inside <script type="application/ld+json">.
// Prevents `</script>`, LINE/PARAGRAPH SEPARATOR, and other injection breakouts even
// when the payload contains admin-editable strings (bio, name, description, etc.).
// See: https://cheatsheetseries.owasp.org/cheatsheets/Cross_Site_Scripting_Prevention_Cheat_Sheet.html
export function safeJsonLd(obj) {
  return JSON.stringify(obj)
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/&/g, "\\u0026")
    .replace(/\u2028/g, "\\u2028")
    .replace(/\u2029/g, "\\u2029");
}
